import React from 'react';
import MixedMediaView from '@/views/campaigns/content-submissions/MixedMediaView';
import layoutStyles from '../OffPlatformLayout.module.scss';

function OffPlatformMixedMediaView() {
  return (
    <div className={layoutStyles.paddedContent}>
      <MixedMediaView isOffPlatform />
    </div>
  );
}

export default OffPlatformMixedMediaView;
